import { customAlphabet } from 'nanoid';

// Human-friendly alphabet: removes confusing characters (0, O, I, l, 1)
// Uses uppercase and lowercase letters plus numbers 2-9
const alphabet = '23456789ABCDEFGHJKMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz';

// Generate 6-character IDs (~916 million possible combinations)
const nanoid = customAlphabet(alphabet, 6);

export function generateSketchId(): string {
  return nanoid();
}
